export const SPORTBOOK_ROUTES = {
  HOME: "/sportsbookV2/sports/",
  FAVOURITES: "/sportsbookV2/Favourites",
  RESULT: "/sportsbookV2/Results",
  MYBETS: "/sportsbookV2/Mybets",
  EXTRAMARKET: "/sportsbookV2/extraMarkets",
  HOMEPAGE: "/sportsbookV2/sports/home",
  LIVE: "/sportsbookV2/sports/live",
  SCHEDULE: "/sportsbookV2/sports/schedule",
  SPORTS: "/sportsbookV2/sports",
  HOME2: "/sportsbook/sports/",
  FAVOURITES2: "/sportsbook/Favourites",
  RESULT2: "/sportsbook/Results",
  MYBETS2: "/sportsbook/Mybets",
  EXTRAMARKET2: "/sportsbook/extraMarkets",
  HOMEPAGE2: "/sportsbook/sports/home",
  LIVE2: "/sportsbook/sports/live",
  SCHEDULE2: "/sportsbook/sports/schedule",
  SPORTS2: "/sportsbook/sports",
  SPORTSBOOKIFRAME: "/sports"
};
